import axiosInstance from './axiosInstance';

export const getAllWebbeyCommission = () =>
    axiosInstance.get("/SalesCommission/GetAllWebbeyCommission");